import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-body3.scss';
import '../font.scss';

const FontBody3: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY3 : props.color
    };

    return (
        <span className={`font font-body3 ${fontClasses(props)}`}>{props.children}</span>
    )
};

export default FontBody3;
